import React from 'react';
import PropTypes from 'prop-types';

import styles from './Modal.css';

const IPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
};

const Modal = ({ children }) => (
  <div className={styles.modal}>
    <div className={styles.modalMain}>
      {children}
    </div>
  </div>
);

Modal.propTypes = IPropTypes;

export { Modal };



// WEBPACK FOOTER //
// ./src/common/modal/Modal.jsx